export default __webpack_public_path__ + "static/assets/2940b371c24203dcc3f41704a9415979.png";